export default {
  nameStep1: '!Hi I am Keybe!',
  nameStep2: 'What\'s your name?',
  nameStep3: 'Hi I am Keybe!',
  nameInput: 'Type your name',
  emailStep1: 'Ohhh!!! What a nice name',
  emailStep2: 'i would like to know you better,',
  emailStep3: 'do you have an email?',
  emailInput: 'Type your email',
  emailExists: 'Email already exists',
  companyStep1: 'A bird told me that you have a brand or project',
  companyStep2: 'how it\'s called?',
  companyExists: 'Company already exists',
  companyInput: 'Brand\'s name',
  animationStep1: ', maybe this is a small step for you,',
  animationStep2: 'but it will definitely mark the story of',
  aboutKeybe: 'About Keybe',
  termsAndConditions: 'Terms and Conditions',
  welcomeToKeybe: 'Having you here is the best!',
  acceptTermsButton: 'Let\'s go!',
  readTerms: 'I\'ve read and accept',
  serviceAgreement: 'the service agreement',
  signinError: 'Login failed',
  registerError: 'Registration failed',
  tutorialStep1: 'Let\'s send your first WhatsApp',
  tutorialStep2: 'Write the cell number which you want to send the message',
  tutorialStep3: 'Write a message',
  brandSize: 'Daily chats of your business',
  wizardSubtitle: 'Create an account and take your sales to the next level',
  alreadyHaveAccount: 'I already have an account',
  nameRequired: 'Please enter your name',
  invalidEmail: 'Please enter a valid email',
  companyRequired: 'Please enter a company name',
  brandType: 'Business Type',
  selectBrandType: 'Select a business type',
  selectBrandTypeRequired: 'Please select a business type',
  selectBrandSize: 'Select a daily chat average',
  between: 'Between',
  brandSizeRequired: 'Please select a daily chat average',
  lastStep: 'Just one step to your best version!',
  atContinueYouAccept: 'By continuing you accept our ',
  writeBrandType: 'Write the business type',
  brandTypeRequired: 'Please enter a business type',
  whichOne: 'Which one',
  errorInWizard: 'Ups! Something went wrong, please try again',
  appTourWelcome: 'Welcome to Keybe!',
  appTourWelcome1: 'In this platform we will build together the path to boost your business sales 🚀.',
  appTourWelcome2: 'Join me on this Tour and I\'ll show you how we will make it possible 👀',
  appTourChatHeader: 'Whenever you enter Keybe, you will arrive at your chats. Here you can see the conversations you have active, those that have been closed and the total of them. You will also have a chat exclusive to communicate with your team.',
  appTourChatPreferences: 'Here you will have the preference control to manage the chats, their configuration, AI add-ons, filters of your conversations, channels and advisors.',
  appTourTopBar: 'In the top bar, you will find the direct access to the value information of your business in Keybe: Chats, People, Sales opportunities and tickets and metrics.',
  appTourPersons: 'Here you find the list of all the people who have interacted with your business from Keybe. You find the data, extradata and a card per contact with the activity of each person or company. In addition, you can create segments with behaviors or data in common according to your interests.',
  appTourSales: 'What do you think of this tool to take control of your sales to the most detailed level possible? Here you can create all kinds of sales opportunities and tickets so that nothing is left in the air and money on the table',
  appTourMetrics: 'The best way to grow is by measuring, that\'s why in Keybe we have metrics in real time for conversations to the detail that you want and the best thing is that you can also measure your CRM',
  appTourTopMenu: 'Here you can control your balance in Keybe, make recharges, set yourself active or inactive and most importantly, stay in touch with our assistance channel to solve any type of doubt.',
  appTourHamburgerMenu: 'In this menu, you can configure all kinds of extensions, connections and Keybe settings with your digital ecosystem, in addition you can create your own microsite in MY KEYBE with included catalog linked to your chat 🥰, create moments and send mass message campaigns ...',
  appTourFinal: 'This Tour is a taste of everything you can do with Keybe to boost your sales and optimize the work of your team. If you want to know in detail how to get the most out of this platform visit our channel of ',
  appTourFinal1: 'to read our step by step',
  appTourRoomCard1: 'Here you can see all your chats',
  appTourRoomCard2: 'You will be notified of new channels with these icons',
  appTourRoomInfo: 'Here you will have information about the user with which you chat',
  appTourRoomActions: 'Transfer to another agent or close the conversation',
  appTourNewRoom: 'Start a WhatsApp conversation from here',
  appTourAssistButton: 'Go back to the tutorials or request help when you need it',
  goBack: 'Go back',
  acceptRequired: 'You must accept the terms and conditions to continue',
  phoneTermsRequired: 'You must enter a phone number',
  vehicleAccesoriesAndParts: 'Automotive Accessories and Repairs',
  healthBeautyAndWellness: 'Health, Beauty and Wellness',
  petAndFieldItems: 'Pet Supplies and Field',
  homeAndDecor: 'Decoration and Home',
  coursesAndEducation: 'Courses and Education',
  fashionAndAccessories: 'Fashion, Clothing and Accessories',
  LeisureTravelTourism: 'Leisure, Travel & Tourism',
  others: 'Others',
  or: 'or',
  clickHere: 'click here',
  yourPersonalPhoneNumber: 'Enter your personal phone number',
  looksLikeYourTryingSignUp: 'Looks like your trying to create a new account in Keybe...',
  youCanDoThisInOtherVersion: 'You can do this in our new version!',
  takeMeThere: 'Take me there',
  createAccountNow: 'Create an account now'
}
